import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Footer } from '../../components/Footer';
import { fetchStores } from '../../functions/fetchStores';
import { useLocalStorage } from '../../hooks/useLocalStorage';
//import { StoreList } from '../../components/StoreList';
import { ReactComponent as Open } from '../../assets/open.svg';
//import { useScrollData } from 'scroll-data-hook';

interface Props extends RouteComponentProps<{ id: string }> {}

const Stores: React.FC<Props> = ({ match }) => {
    const { t } = useTranslation();
    const [storeData, setStoreData] = useState([]);
    const [localStorageData, setLocalStorageData] = useLocalStorage('local_storage_data', '');
    const hasWindow = typeof window !== 'undefined' ? true : false;
    let scrollbar: any = null;
    let smoothScroll: any = null;

    useEffect(() => {
        // eslint-disable-next-line curly
        if (!hasWindow) return;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        scrollbar = require('smooth-scrollbar');
        const plugin = require('../../functions/edgeScrollEasingPlugin');
        console.log('scroll', scrollbar);
        scrollbar.default.use(plugin.default);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        smoothScroll = scrollbar.default.init(document.querySelector('#am_scrollbar'), {
            thumbMinSize: 20,
            renderByPixels: true,
            continuousScrolling: false,
        });
        smoothScroll.addListener((s: any) => {
            console.log(s.offset);
            console.log(smoothScroll._momentum);
        });
        return () => {
            scrollbar && scrollbar.default.destroy(scrollbar);
        };
    }, [hasWindow, match]);

    useEffect(() => {
        // eslint-disable-next-line curly
        if (!hasWindow) return;
        console.log('Localstorage:: ', localStorageData);

        if (localStorageData) {
            console.log('We have data..');

            const storedDate = localStorageData[localStorageData.length - 1];
            if (Date.now() - storedDate < 3.6e6) {
                setStoreData(localStorageData);
                return;
            }
        }
        fetchStores()
            .then((d: any) => {
                // Sort...
                d.sort((a: any, b: any) => a.Items.StoreName.localeCompare(b.Items.StoreName));
                d.push(Date.now());
                console.table(d);
                setLocalStorageData(d);
                setStoreData(d);
            })
            .catch((e) => console.log(e));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasWindow]);

    //console.log(t, match);

    // StoreObject
    // Name | Location |Opening Hours |Store Manager/number

    return (
        <>
            <Helmet defaultTitle="AutoMat | Butiker" titleTemplate="%s AutoMat" />
            <div id="am_scrollbar">
                <div
                    id="am_route_content"
                    className="contact" /*style={{ background: '#e3e3e3' }}*/
                >
                    <div className="am_store_content">
                        <div className="am_row">
                            <h1 className="am_store_message">{t('stores.message')}</h1>
                        </div>
                        <div className="am_row" style={{ marginTop: 100 }}>
                            <div className="am_column am_counter">
                                <div className="am_store_count">
                                    <p>{storeData ? `${storeData.length - 1}` : ''}</p>
                                    <Open />
                                </div>
                            </div>
                            <div className="am_column">
                                <p className="am_store_sub_message">Butiker</p>
                                <p className="am_underline_text">Butiker</p>
                            </div>
                        </div>
                        <div className="am_row" style={{ marginTop: 100, marginBottom: 200 }}>
                            <ul>
                                <span className="am_legend">
                                    <p>{t('stores.store-list.name')}</p>
                                    <p>{t('stores.store-list.address')}</p>
                                    <p style={{ textIndent: '40%' }}>
                                        {t('stores.store-list.open')}
                                    </p>
                                    <p>{t('stores.store-list.nr')}</p>
                                </span>
                                {storeData &&
                                    storeData.slice(0, -1).map((store: any, index: number) => (
                                        <li id="am_store" key={store.PK}>
                                            <Link to={'#'} style={{ pointerEvents: 'none' }}>
                                                <h4>
                                                    {store.Items.StoreName.split(/ (.+)/).map(
                                                        (item: any, i: any) => {
                                                            return (
                                                                <p className="am_inner_h4" key={i}>
                                                                    {item}
                                                                </p>
                                                            );
                                                        }
                                                    )}
                                                </h4>
                                                <p>{store.Items.Address.Street}</p>
                                                <p style={{ textIndent: '40%' }}>
                                                    {`${store.Items.OpeningTime} - ${store.Items.ClosingTime}`}
                                                </p>
                                                <p>{`#${index + 1}`}</p>
                                            </Link>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Stores;
